// extracted by mini-css-extract-plugin
module.exports = {"name":"DependentsLayout_name__2IItp","pages":"DependentsLayout_pages__MA1PF"};